import { DefaultHeaderToSystm } from "src/const";
import { API_PATH } from "src/const/api-urls";
import { createCreDtTm, createMSGID } from "src/utils/helper";
import httpsService from "./httpsService";

export const chargePayer = (
  data: {
    policyNumber: string;
    isBuyer?: boolean;
    fullName?: string;
    email?: string;
    phoneNumber?: string;
    paymentType?: string;
  },
  frSystm: string
) => {
  const msgId = createMSGID(frSystm);
  return httpsService.post(API_PATH.CHARGE_PAYER, data, {
    headers: {
      frSystm: frSystm,
      toSystm: DefaultHeaderToSystm,
      creDtTm: createCreDtTm(),
      msgId: msgId,
    },
    params: {
      msgId: msgId,
    },
  });
};
